export default function MoveDuoVertical() {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2867_15940)">
        <path
          d="M16 10L12 10L12 6L6 2.18557e-07L-2.18557e-07 6L4 6L4 10L10 16L16 10Z"
          fill="var(--quaternery-color)"
        />
        <path
          d="M12 6L8 6L8 10L4 10L4 6L-3.74628e-07 6L6 -3.74628e-07L12 6Z"
          fill="var(--text-secondary-color)"
        />
      </g>
    </svg>
  );
}
